import React from 'react'
import { useRecordContext } from 'react-admin'
import { DeleteButtonWithConfirmation } from 'src/components/uiElements/buttons/DeleteButtonWithConfirmation'
import { operationServices } from 'src/services/sales/operation/operation.service'

export const DisableOperationButton = (props) => {
  const record = useRecordContext()

  return (
    <DeleteButtonWithConfirmation
      {...props}
      handleDeleteFunction={() => operationServices.deleteOperation(record.external_id)}
    />
  )
}
